module.exports = __webpack_public_path__ + "static/media/register-kids.77dfd75a.png";